import { Alert, Box, CircularProgress, Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  BoxTitleApp,
  ButtonApp,
  PageHeaderBox,
  PaperApp,
  TextFieldApp,
  TypographyApp,
} from '../components/custom/CustomComponents';
import { BoxHeaderInicioSesion } from '../components/custom/DedicatedComponents';
import { Context } from '../service/Context';
import theme from '../styles/theme';

// --- Componente InicioSesion ---
const InicioSesion = () => {
  const { idUsuario, iniciarSesion } = useContext(Context);
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (idUsuario) {
      navigate(`/home`);
    }
  }, [idUsuario, navigate]);

  // Manejador del envío del formulario
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    if (!usuario || !contrasena) {
      setError('El usuario y la contraseña son obligatorios.');
      setLoading(false);
      return;
    }

    try {
      const respuesta = await iniciarSesion(usuario, contrasena);
      if (respuesta.exito) {
        navigate(`/home`);
      } else {
        setError(respuesta.mensaje);
      }
    } catch {
      setError('Ocurrió un error inesperado. Inténtalo de nuevo.');
    }
    setLoading(false);
  };

  const logoUrl = '../logo_lema_sin_fondo_zoom.png';

  return (
    <>
      <PageHeaderBox
        sx={{
          backgroundColor: theme.palette.primary.main,
          minHeight: '15vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BoxHeaderInicioSesion component="img" src={logoUrl} alt="Logo InteliScouting - El futuro es hoy" />
      </PageHeaderBox>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '90vh', backgroundColor: theme.palette.background.main }}
        spacing={2}
      >
        <PaperApp sx={{ maxWidth: 450, boxShadow: '0px 0px 2px' }}>
          <BoxTitleApp sx={{ mb: 2 }}>Bienvenido</BoxTitleApp>
          <Box component="form" onSubmit={handleSubmit}>
            <TextFieldApp
              fullWidth
              id="usuario"
              name="usuario"
              label="Nombre de Usuario"
              autoFocus
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              sx={{ my: 1 }}
            />
            <TextFieldApp
              fullWidth
              id="contrasena"
              name="contrasena"
              label="Contraseña"
              type="password"
              value={contrasena}
              onChange={(e) => setContrasena(e.target.value)}
              sx={{ mt: 1, mb: 2 }}
            />
            {error && (
              <Alert severity="error" variant="filled" sx={{ my: 2 }}>
                {error}
              </Alert>
            )}
            <ButtonApp type="submit" fullWidth disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> : <TypographyApp>Acceder</TypographyApp>}
            </ButtonApp>
          </Box>
        </PaperApp>
        <TypographyApp variant="caption" color="text.secondary" sx={{ mt: 3 }}>
          © {new Date().getFullYear()} TechGol. Todos los derechos reservados.
        </TypographyApp>
      </Grid>
    </>
  );
};

export default InicioSesion;
